const fakeClientData = {
  client_code: 'CL123456',
  name: 'Client Test',
  establishment_postcode: '75001',
  establishment_city: 'Paris',
  establishment_phone1: '01 23 45 67 89',
  establishment_phone2: '01 98 76 54 32',
  establishment_email: 'contact@etablissement.fr',
  establishment_address1: "12 Rue de l'Établissement",
  establishment_address2: 'Bâtiment A',
  establishment_country: 'France',
  establishment_contact: 'Jean Dupont',
  establishment_fax: '01 23 45 67 90',
  pickup_name: 'Nom du Point de Retrait',
  pickup_postcode: '69002',
  pickup_city: 'Lyon',
  pickup_phone1: '04 12 34 56 78',
  pickup_phone2: '04 87 65 43 21',
  pickup_email: 'retrait@point.fr',
  pickup_address1: '34 Avenue du Retrait',
  pickup_address2: 'Etage 2',
  pickup_country: 'France',
  pickup_contact: 'Marie Durant',
  pickup_fax: '04 12 34 56 79',
  billing_name: 'Nom de Facturation',
  billing_postcode: '33000',
  billing_city: 'Bordeaux',
  billing_phone1: '05 67 89 01 23',
  billing_phone2: '05 32 10 98 76',
  billing_email: 'facturation@client.fr',
  billing_address1: '56 Rue de la Facturation',
  billing_address2: 'Appartement 3',
  billing_country: 'France',
  billing_contact: 'Paul Martin',
  billing_fax: '05 67 89 01 24',
  email_book: 'emails@client.fr',
  address_book: 'adresses@client.fr',
  siret_number: '123 456 789 00012',
  vat_number: 'FR12345678901',
  ape_naf_code: '4932Z',
  payment_type: 'VIREMENT',
  period: 'MOIS',
  diesel_tax: 0.1,
  vat_status: true,
  pickup_delivery: false,
  payment_time_from_billing: 30,
  automatic_billing: true,
  semi_taut: false,
  porteur_taut: true,
  semi_fourgon: false,
  porteur_fourgon: true,
  semi_frigo: false,
  porteur_frigo: true,
  vingt_metres_cube: false,
  plateau: true,
  tail_lift: false,
  pallet_truck: true,
  pallet_exchanger: false,
  adr: true,
  class_type: '2',
  un_code: 'UN1234',
  grp: 'II',
  comments: 'Aucun commentaire',
};

export default fakeClientData;
